import type { ScopedThreadRef } from "@cleo/contracts";

import type { compressImageToByteLimit } from "~/lib/imageCompression";
import { addComposerImages } from "./chat/composerImageAttachments";

/**
 * UP13 — files dropped on a session row land in THAT session's composer draft
 * (upstream #7892): validated, converted and compressed by the composer's own
 * door (`addComposerImages`, the one image validator the Desk composer and
 * the workspace drop share), never sent. The row's caller opens the session
 * afterwards; the composer reads the attachments from the same draft it
 * always reads.
 */
export async function attachDroppedFilesToSession(input: {
  readonly threadRef: ScopedThreadRef;
  readonly files: ReadonlyArray<File>;
  readonly compress?: typeof compressImageToByteLimit;
}): Promise<{ readonly attached: number; readonly rejected: string | null }> {
  return addComposerImages(
    input.threadRef,
    input.files,
    input.compress ? { compress: input.compress } : {},
  );
}
